import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import AOS from 'aos'
import 'aos/dist/aos.css'

import VueRouter from 'vue-router'
import router from './router'

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import messages from './lang';
import VueI18n from 'vue-i18n'
// library.add(faUserSecret)

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';
// Vue.component('font-awesome-icon', FontAwesomeIcon)

import { store } from './store/store';

Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueI18n)

// window.$ = window.jQuery = window.jquery = require('jquery');
Vue.config.productionTip = false

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: store.getters.selectedLocale.suffix, // set locale
  messages, // set locale messages
})

new Vue({
  created () {
    AOS.init()
  },
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
